import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { ModalButtonProps, ModalButtons } from './types';

import AndroidSpinner from 'inline-icons/android-loading.svg';
import IOSSpinner from 'inline-icons/iOS-loading.svg';
import { isiOS } from 'config';
import { Link } from '../Common';

const TextContainer = styled.div`
  padding-left: 10px
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const LoadingRow = styled.div.attrs({
  dangerouslySetInnerHTML: {
    __html: isiOS ? IOSSpinner : AndroidSpinner
  }
})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 5px;
  svg {
    ${({ theme }) => theme.LoadingIcon}
  }
`;


const ModalButtonGroup = styled.div<{ singleButton: boolean }>`
  display: flex;
  justify-content:  ${({ singleButton }: any) => singleButton ? 'space-around' : 'space-between'};
  text-align: center;
  ${({ theme }) => theme.ModalButtonGroup}
`;

const modalButtonCss = css<ModalButtonProps>`
  width: 48%;
  padding: 15px;
  box-sizing: border-box;
  cursor: pointer;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  letter-spacing: 0;
  text-transform: uppercase;
  -webkit-tap-highlight-color: transparent;
  ${({ highlight, theme }) => `
    border-radius: 10px;
    font: 14px ${theme.fontSemibold};
    ${
      highlight
        ? `
      background-color: ${theme.fitbitDarkGreen};
      color: #ffffff;
    `
        : `
      background-color: ${theme.fitbitLightGray};
      color: ${theme.fitbitDarkGreen};
    `
    }
  `}
`

const ModalButton = styled.span<ModalButtonProps>`
  ${modalButtonCss}
`;

const ModalLinkButton: FC<any> = (props) => (
  <ModalButton {...props}>
    <Link
      to={props.to}
      pageDirection='FORWARD'
    >
      { props.children }
    </Link>
  </ModalButton>
)

export const ButtonGroup: FC<ModalButtons> = ({ buttons }) => (
  <ModalButtonGroup singleButton={buttons.length === 1}>
    {buttons.map(
      ({ highlight, text, onClick, id, loading, disabled, to, pageDirection }, index) => {
        
        const ButtonType = (to ? ModalLinkButton : ModalButton) as React.ElementType

        return (
          <ButtonType
            highlight={highlight}
            onClick={loading || disabled ? undefined : onClick}
            key={index}
            aria-label={id}
            id={id}
            to={to}
            pageDirection={pageDirection}
          >
            
            {loading ? 
              <LoadingContainer>
                <LoadingRow /> 
                <TextContainer>
                  {text}
                </TextContainer>
              </LoadingContainer>
              : 
              text
            }
            
          </ButtonType>
        )
      }
    )}
  </ModalButtonGroup>
);
